import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";

/** Obtiene las compañías disponibles por país.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Compañías por país. */
export async function GetCompaniesByCountry(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups/companies/countries/available",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las compañías agrupadas por países.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Compañías por países. */
export async function GetCompaniesByCountries(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups/companies/countries",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Crea un nuevo grupo empresarial.
 * @param {Object} data - Datos del grupo empresarial.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function CreateBusinessGroup(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene un grupo empresarial por su ID.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Grupo empresarial. */
export async function GetBusinessGroup(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups/idgroup",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene los grupos empresariales por país.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Grupos empresariales. */
export async function GetBusinessGroupByCountries(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups/countries",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Edita un grupo empresarial existente.
 * @param {Object} data - Datos actualizados del grupo.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function EditBusinessGroup(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "PUT",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Administra los grupos empresariales.
 * @param {Object} data - Datos de administración.
 * @returns {Promise<*>} Resultado de la administración. */
export async function ManageBusinessGroups(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL,
    url: "business/groups/administrations",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Lista los grupos empresariales con permisos del usuario.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de grupos. */
export async function ListBusinessGroup(data) {
  const token = await getTokenMicro();

  return axios({
    method: "POST",
    baseURL: env.REACT_APP_API_URL_USERS,
    url: "users/companies/permissions",
    data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}